module.exports = __webpack_public_path__ + "img/20191026151103993.6e72cea3.jpg";